<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    data() {
        return {
            form: {
                active: true,
            },
            disableOnSubmit : false,
            dictionary: {
                en: {
                    attributes: {
                        my_notion_of_ten: 'Perhaps start by defining a 10/10 score and then consider what a few others scores might look like on the way down to 0. Then rate yourself, further below.',
                        my_current_score: 'My Current Score',
                        my_aspirational_score: 'My Aspirational Score',
                    }
                },
            }
        }
    },

    props: ['url', 'getUrl', 'previous', 'next'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
    },

    created() {
    },

    mounted() {
        this.getData();
        this.$validator.localize(this.dictionary);
    },

    watch: {
    },

    methods: {
        getData() {
            axios
                .get(this.getUrl,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    this.form = response.data.data;
                    this.form.my_current_score = this.form.my_current_score != null
                        ? this.form.my_current_score
                        : 1;
                    this.form.my_aspirational_score = this.form.my_aspirational_score != null
                        ? this.form.my_aspirational_score
                        : 1;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },

    components: {
        VueSlider
    }
}
</script>
